import React from "react";
import { Link } from "react-router-dom";

const FooterTwo = () => {
  return (
    <footer>
      <div className="footer-area-two" style={{ backgroundColor: "#292930" }}>
        <div className="container">
          {/* Footer Top Section */}
          <div className="footer-top-two">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-8">
                <div className="footer-content-two text-center">
                  <div className="logo">
                    <Link to="/">
                      <img src="/SaiChanduLogo.png" alt="Sai Chandu Logo" />
                    </Link>
                  </div>
                  <p>
                    Hi, I'm <strong>Sai Chandu</strong>, a passionate full-stack
                    developer. I specialize in building scalable web
                    applications and user-friendly experiences.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom Section */}
          <div className="footer-bottom-two">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="copyright-text">
                  <p>
                    © {new Date().getFullYear()} Sai Chandu. All Rights
                    Reserved.
                  </p>
                </div>
              </div>

              {/* Social Media Links */}
              <div className="col-md-6">
                <div className="footer-social-two">
                  <ul className="list-wrap d-flex align-items-center gap-3">
                    <li className="title">Follow Me</li>
                    <li>
                      <a href="mailto:22a91a61d1@aec.edu.in">
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png"
                          alt="Email"
                          width="35"
                          height="38"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://github.com/Saichandu03"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
                          alt="GitHub"
                          width="32"
                          height="32"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/in/saichandu-adapa-143b41254/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg"
                          alt="LinkedIn"
                          width="32"
                          height="32"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/saichandu_adapa/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                          alt="Instagram"
                          width="32"
                          height="32"
                        />
                      </a>
                    </li>
                   
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
